import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'article-card-list, app-article-card-list',
  templateUrl: './article-card-list.component.html',
  standalone: false,
})
export class ArticleCardListComponent implements OnInit {
  @Input() title = 'Category Name';
  ngOnInit() {}
}
